import {useNavigate, useParams} from "react-router-dom";
import React, {useEffect, useMemo, useState} from "react";
import Grid from "@mui/material/Grid";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Card, CircularProgress} from "@mui/material";
import {useAction} from "../../hooks/useAction";
import { HttpAuth } from "src/http/user/httpAuth";

interface RecoverPasswordMessages {
    title: string;
    subtitle: string;
}

const RecoverPassword = () => {
    const {guid} = useParams();
    const navigate = useNavigate()
    const {snackbarError} = useAction()
   
    const [loading, setLoader] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);
    
    const messages: RecoverPasswordMessages = useMemo(() => {
        if (loading)
            return {
                title: 'Recuperando contraseña! ⏳',
                subtitle: 'Por favor aguarde, estamos reestableciendo su contraseña'
            }
        
        if (error)
            return {
                title: 'Al parecer tuvimos un error ⚠️',
                subtitle: ''
            }

        return {
            title: 'Contraseña recuperada! 🔒',
            subtitle: 'La contraseña se reestableció correctamente. Te redireccionaremos al login en breve.'
        }
    }, [loading, error])

    const handleErrors = () => {
        snackbarError('Error. La contraseña no se pudo restablecer.');
        setError(true);
    }
    
    useEffect(() => {
        if (guid && guid !== '' && loading) {
            HttpAuth.confirmChangePassword(guid)
                .then((r) => {
                    if (r.tieneError) {
                        handleErrors();
                    }
                })
                .catch(handleErrors)
                .finally(() => setLoader(false))
        }
    }, [guid]);

    useEffect(() => {
        if (!loading) {
            setTimeout(() => {
                navigate('/login')
            }, 5000)
        }
    }, [loading]);
    
    return (
        <Grid container justifyContent={'center'} alignItems={'center'} sx={{height: '100vh !important'}}>
            <Card sx={{ zIndex: 1 }}>
                <CardContent sx={{ p: theme => `${theme.spacing(12, 9, 7)} !important` }}>
                    <Box sx={{ mb: 6 }}>
                        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2, gap: 4 }}>
                            <Typography variant='h5'>
                                {messages.title}
                            </Typography>
                            <img
                                src={`/images/fogaba-resized.png`}
                                height={'60'}
                                alt={`logo-img`}
                            />
                        </Box>
                        <Typography variant='body2'>
                            {messages.subtitle}
                        </Typography>
                    </Box>
                    
                    {
                        loading &&
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            <CircularProgress />
                        </Box>
                    }
                </CardContent>
            </Card>
        </Grid>
    )
}


export default RecoverPassword